/**
 * @generated SignedSource<<d6fbcda8d92e3bde5fa378bef117a883>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePublicClubsSearchQuery$variables = {
  search: string;
};
export type usePublicClubsSearchQuery$data = {
  readonly publicClubs: ReadonlyArray<{
    readonly backgroundImage: {
      readonly publicId: string;
    } | null | undefined;
    readonly city: string | null | undefined;
    readonly id: string | null | undefined;
    readonly logoImage: {
      readonly publicId: string;
    } | null | undefined;
    readonly name: string;
    readonly slug: string;
    readonly state: string | null | undefined;
  } | null | undefined>;
};
export type usePublicClubsSearchQuery = {
  response: usePublicClubsSearchQuery$data;
  variables: usePublicClubsSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "clubName",
        "variableName": "search"
      }
    ],
    "concreteType": "UnauthenticatedClub",
    "kind": "LinkedField",
    "name": "publicClubs",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnauthenticatedImage",
        "kind": "LinkedField",
        "name": "logoImage",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePublicClubsSearchQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePublicClubsSearchQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "dbea8368c5c8b70a41d0157ecb95fdf0",
    "id": null,
    "metadata": {},
    "name": "usePublicClubsSearchQuery",
    "operationKind": "query",
    "text": "query usePublicClubsSearchQuery(\n  $search: String!\n) {\n  publicClubs(clubName: $search) {\n    id\n    slug\n    name\n    state\n    city\n    logoImage {\n      publicId: renderingKey\n    }\n    backgroundImage {\n      publicId: renderingKey\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8d1de20bf1255acb3f4573c3f5c82d0";

export default node;
